import { render } from "./FilterButton.vue?vue&type=template&id=0b451f36&scoped=true&ts=true"
import script from "./FilterButton.vue?vue&type=script&lang=ts"
export * from "./FilterButton.vue?vue&type=script&lang=ts"

import "./FilterButton.vue?vue&type=style&index=0&id=0b451f36&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b451f36"]])

export default __exports__